import { FadeUp } from "./_shared";
import { ACTIVATION_URL } from "@/lib/links";
import { PostIntakeSteps } from "./_partials/PostIntakeSteps";

export default function FinalCTA() {
  return (
    <section
      id="join"
      data-testid="final-cta-section"
      className="relative py-24 md:py-36 bg-foreground text-background overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
        }}
      />
      <div className="relative max-w-4xl mx-auto px-4 md:px-8 text-center">
        <FadeUp>
          <div className="font-mono text-[0.65rem] uppercase tracking-[0.24em] text-background/55">
            <span className="text-accent">§</span> Begin
          </div>
          <h2 className="mt-6 font-display font-bold tracking-tight leading-[1.08] text-[clamp(2rem,5vw,3.5rem)] text-background">
            Your Health Data Already Tells a Story.
            <br />
            <em className="not-italic text-accent">Integrated Wellness Helps Connect It.</em>
          </h2>
          <p className="mt-7 max-w-2xl mx-auto text-lg md:text-xl text-background/75 leading-relaxed">
            Start with your goals and current health information. Add labs, body composition,
            wearables, genetics and other data as available. Integrated Clinical Intelligence
            brings it together into one evolving optimization profile.
          </p>
        </FadeUp>

        <FadeUp delay={0.1} className="mt-10">
          <a
            href={ACTIVATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-start-analysis"
            className="iw-btn-red inline-flex items-center gap-2 px-10 py-5 text-[0.75rem]"
          >
            Start Your Optimization Analysis <span aria-hidden>→</span>
          </a>
          <PostIntakeSteps testId="final-cta-post-intake-steps" inverse className="mt-5 justify-center" />
        </FadeUp>
      </div>
    </section>
  );
}
